
export interface DischargeConditions {
    id: number;
    folder_id: number;
    type?: 'Informative' | 'Pre-commesment' | 'Pre-occupation';
    case_officer_name?: string;
    validation_date?: string;
    contact_no?: string;
    reference_no?: string;
    email?: string;
    decision_date?: string;
    short_description: string;
    description: string;
    status?: 'Approved' | 'Application submitted' | 'Pending' | 'Informative';
    drawing_file?: string;
    decision_notice_file?: string;
    condition_no: number;
    discharge_condition_followup: DischargeConditionFollowup[];
}

export interface DischargeConditionFollowup {
    id: number;
    discharge_condition_id: number;
    note: string;
}

export interface Status {
    name: string;
    colorCode: string;
}

export interface DischargeConditionTypes {
    type: string;
}

export const statusList: Status[] = [
    {
        name: "Approved",
        colorCode: '#7FF2B3'
    },
    {
        name: "Application submitted",
        colorCode: '#FBFF00'
    },
    {
        name: "Pending",
        colorCode: '#FFC300'
    },
    {
        name: "Informative",
        colorCode: '#DDDDDD'
    }
];

export const dischargeConditionTypes: DischargeConditionTypes[] = [
    {
        type: 'Informative'
    },
    {
        type: 'Pre-commesment'
    },
    {
        type: 'Pre-occupation'
    }
];